import React from "react";
import { TabbedShowLayout, Tab, ShowProps } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import PersonInCharge from "./PersonInCharge";
import { Grid } from "@material-ui/core";
import Financial from "./Financial";
import ShowWrapper from "../../components/ShowWrapper";

const CompanyShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/companies", title: "Companies" },
    { link: `/companies/${id}`, title: id },
  ];

  return (
    <>
      <ShowWrapper breadcrumb={breadcrumb} actions={null} {...props}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Financial">
                <Financial {...props} />
              </Tab>
              <Tab label="Person In Charge">
                <PersonInCharge {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default CompanyShow;
